import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { Empty_FeildActivity_Interface, FeildActivity_Interface } from 'src/app/Interface/FeildActivity_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { ExpirationService } from 'src/app/Service/Expiration/Expiration.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-ExpirationEdit',
  templateUrl: './ExpirationEdit.component.html',
  styleUrls: ['./ExpirationEdit.component.scss']
})
export class ExpirationEditComponent implements OnInit {
  EditRecord:Number

  constructor(
    private Expiration_Service:ExpirationService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private route: ActivatedRoute
  ) { }
  ngOnInit() {

    this.EditExpiration=new FormGroup({
      id :new FormControl(),
      Title:new FormControl(null,Validators.required),
      Day:new FormControl(null,Validators.required),
    })
    this.EditRecord = Number(this.route.snapshot.paramMap.get('id'))

    this.Nav_Service.CheckValidPage(19).subscribe(
      data=>{
        this.Expiration_Service.GetSingle(this.EditRecord).subscribe(
          data=>{
            this.get_Form_Id().setValue(data.id)
            this.get_Form_Title().setValue(data.title)
            this.get_Form_Day().setValue(data.code)

          },error=>{
            // AuthInterceptor owns authentication; feature errors must preserve credentials.

          }
        )
      }
      ,error=>{
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

    //#region  Form Add

    EditExpiration:FormGroup;

    get_Form_Id(){
      return this.EditExpiration.get('id') as FormControl;
    }

    get_Form_Title(){
      return this.EditExpiration.get('Title') as FormControl;
    }

    get_Form_Day(){
      return this.EditExpiration.get('Day') as FormControl;
    }


    //#endregion

    InProccessing:boolean=false

    SubmitEditExpiration(){
      var Record:FeildActivity_Interface =Empty_FeildActivity_Interface()
      Record.id=this.get_Form_Id().value
      Record.title=this.get_Form_Title().value
      Record.code=this.get_Form_Day().value
      this.InProccessing=true
      this.Expiration_Service.EditExpiration(Record).subscribe(
        data=>{
          this.InProccessing=false
          if(data.id==-2){
            this.Alertify_Service.ErrorMessage("عنوان وارد شده ، در لیست وجود دارد")
          }
          else{

            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
          }
        },error=>{
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
    }


}
